import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "title-container"
};
var _hoisted_2 = ["src"];
var _hoisted_3 = {
  class: "content"
};
var _hoisted_4 = {
  class: "logo-container"
};
var _hoisted_5 = {
  class: "title"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "actions"
};
var _hoisted_8 = ["href"];
var _hoisted_9 = ["src"];
var _hoisted_10 = {
  class: "bottom-bar"
};
var _hoisted_11 = ["src"];
var _hoisted_12 = ["href"];
var _hoisted_13 = {
  class: "loading-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_loading = _resolveComponent("van-loading");
  var _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: "download",
    style: _normalizeStyle($options.bgStyle)
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("img", {
    class: _normalizeClass([['logo', 'rotate'], "logo"]),
    src: $data.logo,
    alt: "logo"
  }, null, 8, _hoisted_2), _cache[2] || (_cache[2] = _createTextVNode(" 起泡 ", -1))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
    src: $data.openapptitle,
    alt: "openapptitle",
    class: "title"
  }, null, 8, _hoisted_6)])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("a", {
    class: "btn android",
    href: $data.androidUrl,
    target: "_blank",
    rel: "noopener",
    onClick: _cache[0] || (_cache[0] = function () {
      return $options.onOpenAppClick && $options.onOpenAppClick.apply($options, arguments);
    })
  }, [_createElementVNode("img", {
    src: $data.openappicon,
    alt: "Android",
    class: "icon"
  }, null, 8, _hoisted_9), _cache[3] || (_cache[3] = _createTextVNode(" 打开起泡App ", -1))], 8, _hoisted_8)])])], 4), _createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    src: $data.logo,
    alt: "logo",
    class: "logo"
  }, null, 8, _hoisted_11), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "slogan"
  }, "看历史、聊文化、找圈子", -1)), _createElementVNode("a", {
    class: "open-app-btn",
    href: $data.androidUrl,
    target: "_blank",
    rel: "noopener",
    onClick: _cache[1] || (_cache[1] = function () {
      return $options.onOpenAppClick && $options.onOpenAppClick.apply($options, arguments);
    })
  }, "打开 App", 8, _hoisted_12)]), _createVNode(_component_van_overlay, {
    show: $data.opening
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_13, [_createVNode(_component_van_loading, {
        size: "24",
        color: "#fff"
      }), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "loading-text"
      }, "正在打开 App...", -1))])];
    }),
    _: 1
  }, 8, ["show"])], 64);
}